import axiosInstance from './axios';

const getDashboardOverview = ({
  role,
  user,
  department,
  period,
  customStart,
  customEnd,
}) => {
  return axiosInstance
    .post('/dashboard/overview/', {
      role: Boolean(role),
      user,
      department,
      period,
      custom_start: customStart,
      custom_end: customEnd,
    })
    .then((res) => {
      return res.data;
    });
};

const getDashboardCompliance = ({
  reportType,
  period,
  customStart,
  customEnd,
  department,
  subDepartment,
  category,
  assetDepartment,
  asset,
}) => {
  return axiosInstance
    .post('/dashboard/compliance/', {
      report_type: reportType,
      period,
      custom_start: customStart,
      custom_end: customEnd,
      department,
      sub_department: subDepartment,
      category,
      asset_department: assetDepartment,
      asset,
    })
    .then((res) => {
      return res.data;
    });
};

const departmentReport = ({
  department,
  subDepartment,
  category,
  asset,
  period,
  custom_start,
  custom_end,
}) => {
  const params = new URLSearchParams();
  
  if (department) params.append('department', department);
  if (subDepartment) params.append('subDepartment', subDepartment);
  if (category) params.append('category', category);
  if (asset) params.append('asset', asset);
  if (period) params.append('period', period);
  if (custom_start) params.append('custom_start', custom_start);
  if (custom_end) params.append('custom_end', custom_end);

  return axiosInstance
    .post(`/v1/department/report/array/?${params.toString()}`)
    .then((res) => {
      return res.data;
    });
};

const assetReport = ({
  department,
  subDepartment,
  category,
  asset,
  period,
  custom_start,
  custom_end,
}) => {
  const params = new URLSearchParams();
  
  if (department) params.append('department', department);
  if (subDepartment) params.append('subDepartment', subDepartment);
  if (category) params.append('category', category);
  if (asset) params.append('asset', asset);
  if (period) params.append('period', period);
  if (custom_start) params.append('custom_start', custom_start);
  if (custom_end) params.append('custom_end', custom_end);

  return axiosInstance
    .post(`/v1/inspection/report/array/?${params.toString()}`)
    .then((res) => {
      return res.data;
    });
};

const getDashboardServicePrediction = ({
  site,
  department,
  subDepartment,
  category,
  period,
  startDate,
  endDate,
}) => {
  return axiosInstance
    .post('/dashboard/prediction/', {
      site,
      department,
      sub_department: subDepartment,
      category,
      period,
      start_date: startDate,
      end_date: endDate,
    })
    .then((res) => {
      return res.data;
    });
};

const DashboardServices = {
  getDashboardOverview,
  getDashboardCompliance,
  getDashboardServicePrediction,
  departmentReport,
  assetReport,
};

export default DashboardServices;
